import { useLibrary } from "contexts";
import sortByCreatedAt from "utils/sortByCreatedAt";
import StoryGroup from "./StoryGroup";
import PropTypes from "prop-types";

export function Library({ books = [], limit, orientation, ...props }) {
  const { stories } = useLibrary();

  const collection = books.length > 0 ? books : stories;
  const sortedBooks = sortByCreatedAt(collection) || [];

  return (
    <StoryGroup
      books={sortedBooks.slice(0, limit || 100)}
      orientation={orientation || "portrait"}
      {...props}
    />
  );
}

Library.propTypes = {
  books: PropTypes.array,
  limit: PropTypes.number,
  orientation: PropTypes.string,
  scrollable: PropTypes.bool,
};
